<div class="m-3">
  <app-grid-table
    [columns]="columns"
    [rowModelType]="rowModelType"
    [cacheBlockSize]="cacheBlockSize"
    [maxBlocksInCache]="maxBlocksInCache"
    [datasource]="datasource"
    (searchChange)="onSearch($event)"
    [showSearch]="true"
    [autoHeight]="false"
    [rowHeight]="rowHeight"
    [gridHeight]="500"
    [loading]="isLoading()"
  ></app-grid-table>
</div>
